<template>
    <div class="info-address">
        <small>{{ `${t('ProductForm.Geolocation.addressCompletedByPartner')}` }}</small>
    </div>
    <FormKit
        disabled
        type="text"
        step="any"
        :label="props.number + '. Adresse*'"
        name="address"
        placeholder="Adresse"
    />
    <FormKit
        disabled
        type="text"
        step="any"
        :label="props.number + '. Code Postal*'"
        name="zipCode"
        placeholder="Code Postal"
    />
    <FormKit
        disabled
        type="text"
        step="any"
        :label="props.number + '. Ville*'"
        name="city"
        placeholder="Ville"
    />
    <FormKit
        disabled
        type="select"
        :label="props.number + '. Pays*'"
        name="country"
        placeholder="Pays"
        :options="props.optionsCountry"
    />
    <FormKit
        disabled
        type="textarea"
        step="any"
        rows="2"
        :label="props.number + '. Adresse correspondant aux coordonnées*'"
        name="formattedAddress"
        placeholder="Adresse complète"
    />
    <FormKit
        disabled
        type="number"
        step="any"
        :label="props.number + '. Latitude*'"
        name="latitude"
        placeholder="Latitude"
    />
    <FormKit
        disabled
        type="number"
        step="any"
        :label="props.number + '. Longitude*'"
        name="longitude"
        placeholder="Longititude"
    />
</template>


<script setup lang="ts">
    import { useI18n } from "vue-i18n";
    
    const { t } = useI18n();
    
    // Define Props
    const props = defineProps({
        'index': {
            type: Number
        },
        'number': {
            type: Number
        },
        'reference': {
            type: Object,
            default: () => ({
                manualMethod: null,
                address: null,
                zipCode: null,
                city: null,
                country: null,
                latitude: null,
                longitude: null
            })
        },
        'optionsCountry': {
            type: Object
        }
    });
</script>

<style scoped lang="scss">
    .info-address {
        margin-bottom: 10px;
    }
</style>
